const utils = require('./utils');
const postBookingUtils = require('../../../utils/postbooking/js/utils');

module.exports = {
    getSeatsInfoFromBookingInfo(bookingInfo = {}) {
        const sections = [].concat(utils.getSections(bookingInfo) || []);
        const travellers = bookingInfo.travellers || [];

        travellers.forEach((traveller) => {
            const travellerSeats = traveller.seats || [];
            sections.forEach((section) => {
                const seat = utils.findSelectedAncillaryBySection(section, travellerSeats);
                const assignedSeat = Odigeo._.get(seat, 'seatDescription.assignedSeat');

                section.seatsList = section.seatsList || [];
                if (assignedSeat) {
                    section.seatsList.push(assignedSeat);
                }
            });
        });

        return sections;
    },

    haveAllTravellersAttachedInAllAvailableSegments(bookingInfo = {}) {
        const sections = [].concat(utils.getSections(bookingInfo) || []);
        const travellers = bookingInfo.travellers || [];
        let allAttachedInAllSegments = true;

        for (let i = 0; i < travellers.length && allAttachedInAllSegments; i++) {
            const traveller = travellers[i];
            const travellerSeatsList = traveller.seats || [];
            allAttachedInAllSegments = allAttachedInAllSegments
                && travellerSeatsList.length === sections.length;

            sections.forEach((section) => {
                const seat = utils.findSelectedAncillaryBySection(section, travellerSeatsList);
                const assignedSeat = Odigeo._.get(seat, 'seatDescription.assignedSeat');

                allAttachedInAllSegments = allAttachedInAllSegments
                    && assignedSeat !== undefined;
            });
        }

        return allAttachedInAllSegments;
    },

    weHaveCoverage(catalogueData) {
        const catalogue = Odigeo._.get(catalogueData, 'availableAncillariesOptionsDTO.ancillaryOptionsContainer.seatMapResultsResponse', []);
        return catalogue.length > 0;
    },

    isAvailable(bookingInfo, catalogueData) {
        return !postBookingUtils.haveAnyFlightCancelled(bookingInfo)
        && this.weHaveCoverage(catalogueData)
        && postBookingUtils.remainsTimeToBookTheProduct(bookingInfo);
    },

    areAllProvidersActiveOF2(bookingInfo = {}, providerABs) {
        const sections = utils.getSections(bookingInfo) || [];
        const sectionProviders = sections.map((section) => section.provider);
        return sectionProviders.length > 0 && sectionProviders.every((provider) => providerABs[provider]);
    },
};
